var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalProfitPercent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8062 0.38711C21.2083 0.400161 21.5237 0.736672 21.5106 1.13873C21.2353 9.61874 14.1392 16.2632 5.65982 15.988C5.25777 15.9749 4.94242 15.6384 4.95547 15.2364C4.96852 14.8343 5.30503 14.519 5.70709 14.532C13.383 14.7812 19.8055 8.76672 20.0546 1.09147C20.0677 0.689409 20.4042 0.374058 20.8062 0.38711Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3225 0.160938C20.6359 -0.0912543 21.0944 -0.0416369 21.3466 0.271762L23.8377 3.36734C24.0898 3.68074 24.0402 4.13924 23.7268 4.39143C23.4134 4.64362 22.9549 4.59401 22.7027 4.28061L20.2117 1.18503C19.9595 0.871633 20.0091 0.413131 20.3225 0.160938Z",
    fill: "#0F20E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3439 0.269912C21.5972 0.582487 21.549 1.04115 21.2365 1.29436L18.2064 3.74897C17.8938 4.00218 17.4352 3.95406 17.182 3.64148C16.9287 3.32891 16.9769 2.87025 17.2894 2.61704L20.3195 0.162429C20.6321 -0.0907843 21.0907 -0.0426623 21.3439 0.269912Z",
    fill: "#0F20E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49453 22.3264C2.76981 13.8463 9.86593 7.20175 18.3453 7.477C18.7474 7.49005 19.0627 7.82656 19.0497 8.22862C19.0366 8.63068 18.7001 8.94603 18.298 8.93298C10.6222 8.6838 4.19966 14.6984 3.95051 22.3736C3.93745 22.7757 3.60094 23.091 3.19889 23.078C2.79683 23.0649 2.48148 22.7284 2.49453 22.3264Z",
    fill: "#0F20E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.271762 19.0691C0.58516 18.8169 1.04366 18.8666 1.29585 19.18L3.78687 22.2755C4.03906 22.5889 3.98945 23.0474 3.67605 23.2996C3.36265 23.5518 2.90415 23.5022 2.65195 23.1888L0.160938 20.0932C-0.0912543 19.7798 -0.0416369 19.3213 0.271762 19.0691Z",
    fill: "#0F20E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.81855 19.8168C7.07176 20.1294 7.02364 20.588 6.71107 20.8412L3.68102 23.2958C3.36844 23.5491 2.90978 23.5009 2.65657 23.1884C2.40336 22.8758 2.45148 22.4171 2.76405 22.1639L5.7941 19.7093C6.10668 19.4561 6.56534 19.5042 6.81855 19.8168Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalProfitPercent);
export default __webpack_public_path__ + "static/media/total_profit_percent.46b42b05a43fec4186c59e6a4fa12ef2.svg";
export { ForwardRef as ReactComponent };